@charset "UTF-8";

/* src/app/shared/components/source-picker/source-picker.component.scss */
.source-container {
  overflow-y: auto;
  position: relative;
  height: calc(100dvh - 295px);
  scroll-padding-top: 20px;
}
.hideChildren ~ ul {
  display: none;
}
.line-divider {
  border-top: 1px solid #bdbdbd;
  display: flex;
}
#sourceFooter {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1rem;
  height: 80px;
  background-color: #eaeaea;
  border-top: 1px solid #cccccc;
}
ul,
#myUL {
  list-style-type: none;
}
#myUL {
  margin: 0;
  padding: 0;
}
.caret {
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.caret::before {
  content: "\25b6";
  color: black;
  display: inline-block;
  margin-right: 6px;
}
.caret-down::before {
  -ms-transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}
.nested {
  display: none;
}
.active {
  display: block;
  padding: 0;
}
.checkbox-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.css-label {
  cursor: pointer;
}
.css-checkbox {
  display: none;
}
.fa {
  color: white;
  line-height: 16px;
  border-radius: 4px;
}
.fa-plus {
  padding-top: 2px;
  padding-right: 2px;
  padding-left: 2px;
  background-color: #006a7c;
  display: block;
}
.fa-minus {
  padding-top: 1px;
  padding-right: 2px;
  padding-left: 2px;
  background-color: #006a7c;
  display: block;
}
.highlight-name {
  font-weight: 900;
}
.highlight-bg {
  background-color: #46707d;
}
.highlight-bg .bank-info-icon,
.highlight-bg .highlight-name {
  color: #fff;
}
li.treeitem-focused.highlight-bg:focus-visible {
  outline: none;
  border-radius: 1px;
  box-shadow: 0 0 0 1px #fff, 0 0 0 2px #000;
}
.div-question {
  position: relative;
  vertical-align: middle;
}
.bank-items :hover {
  cursor: pointer;
  font-weight: 900;
}
.padding-align {
  position: relative;
  top: 6px;
}
.align-folder {
  top: 3px;
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.modal-dialog-bank-info-new {
  position: relative;
  top: 50%;
  width: 600px;
  z-index: 1010;
  margin: 0px auto;
  transform: translateY(-50%);
}
.modal-dialog-bank-info-new .modal-content {
  height: auto;
}
.modal-dialog-bank-info-new .modal-content iframe {
  height: 378px;
  width: 552px;
}
.modal-overlay {
  background-color: rgba(0, 0, 0, 0.2);
}
.modal-container-new {
  position: relative;
  width: 100%;
  background: transparent;
  height: 100%;
}
.modal-header-new {
  background-color: #174d5c;
  color: #fff;
  height: 45px;
  padding: 12px 18px 12px 20px;
}
.modal-header-new .modal-title {
  color: #fff;
  font-size: 14px;
  line-height: 1.5;
}
button.close {
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
}
.close {
  height: 20px;
  width: 20px;
  font-size: 21px;
  font-weight: bold;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 1;
  filter: alpha(opacity=30);
}
.modal-body-new {
  position: relative;
  flex: 1 1 auto;
  padding: 30px;
}
.modal-body-new h3 {
  color: #46707d;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.5;
  margin-top: 0;
  margin-bottom: 5px;
}
.label-info {
  font-size: 14px;
  font-weight: bold;
}
.label-span {
  font-size: 14px;
  font-weight: 400;
}
.label-question {
  font-weight: normal;
  font-size: 12px;
  display: inline;
}
.label-span-question {
  font-weight: normal;
  font-size: 12px;
  display: inline;
  margin-right: 4px;
}
.modal-footer-new {
  display: flex;
  align-items: center;
  padding: 1rem;
  border-top: 1px solid #e9ecef;
}
.modal-footer-new button {
  width: 130px;
}
.bank-info-icon {
  font-size: 20px;
  color: #006a7c;
}
ul.tree {
  position: relative;
  background: white;
  padding: 20px;
  font-size: 0.85rem;
  font-weight: 400;
  line-height: 1.5;
}
ul.tree span {
  font-size: 15px;
  letter-spacing: 0.4px;
}
ul.tree .fa-folder-open,
ul.tree .fa-folder {
  color: #007bff;
}
ul.tree .fa-html5 {
  color: #f21f10;
}
ul.tree ul {
  padding-left: 5px;
  list-style: none;
}
ul.tree ul li {
  position: relative;
  padding-left: 15px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
ul.tree ul li:before {
  position: absolute;
  top: 15px;
  left: 0;
  width: 10px;
  height: 1px;
  margin: auto;
  content: "";
  background-color: #666;
}
ul.tree ul li:after {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 1px;
  height: 100%;
  content: "";
  background-color: #666;
}
ul.tree ul li:last-child:after {
  height: 15px;
}
ul.tree ul li .bank-info-btn {
  display: flex;
  align-items: center;
}
ul.tree ul li .bank-info-btn:hover,
ul.tree ul li .bank-info-btn:focus {
  text-decoration: none;
}
ul.tree ul a {
  cursor: pointer;
}
ul.tree ul a:hover {
  text-decoration: none;
}
.icon-sm {
  position: relative;
  top: 2px;
  width: 18px;
}
.source-text {
  margin-left: 4px;
}
@media (max-width: 640px), (max-height: 550px) {
  .source-container {
    height: calc(100vh - 104px);
  }
}
@media (max-width: 575px) {
  #bankInfo .modal-overlay {
    display: flex;
    justify-content: center;
    padding: 24px 0;
  }
  #bankInfo .modal-overlay .modal-container-new {
    max-width: 95dvw;
    display: flex;
  }
  #bankInfo .modal-overlay .modal-container-new .modal-content {
    height: fit-content;
    max-height: 100%;
  }
  #bankInfo .modal-overlay .modal-container-new .modal-content .modal-header-new {
    padding: 12px 18px 12px 18px;
    align-items: center;
  }
  #bankInfo .modal-overlay .modal-container-new .modal-content .modal-body-new {
    overflow-x: hidden;
    padding: 16px 12px 16px 7px;
    width: 100%;
  }
}
dl.question-types-list {
  margin: 0;
}
dl.question-types-list .question-type-item {
  margin-bottom: 5px;
}
dl.question-types-list .question-type-item > dt,
dl.question-types-list .question-type-item > dd {
  display: inline;
  margin: 0;
}
dt.label-question::after {
  content: " : ";
}
/*# sourceMappingURL=source-picker.component.css.map */
